import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FlexLayoutModule } from "@angular/flex-layout";
import { OverlayModule } from "@angular/cdk/overlay";

import { AppComponent } from "./app.component";
import { AdministrativeModule } from "./administrative/administrative.module";
import { CommonModule } from "./common/common.module";
import { DashboardModule } from "./dashboard";
import { SessionsModule } from "./sessions/sessions.module";
// End users no longer login to the webapp
import { UserModule } from "./user/user.module";
import { LoginModule } from "./login/login.module";
import { MaterialAppModule } from "./ngmaterial.module";
import { GenericTableModule } from "./genericTable/generic-table.module";
import { ClientAccessModule } from "./client-access/client-access.module";

// Define the routes
const ROUTES = [
	{
		path: "",
		redirectTo: "login",
		pathMatch: "full"
	}, {
		path: "**",
		redirectTo: "login",
		pathMatch: "full"
	}
];

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		RouterModule.forRoot(ROUTES),
		AdministrativeModule,
		CommonModule,
		DashboardModule,
		SessionsModule,
		MaterialAppModule,
		FlexLayoutModule,
		// End users no longer login to the webapp
		UserModule,
		LoginModule,
		GenericTableModule,
		OverlayModule,
		ClientAccessModule
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
